import React, { useEffect, useState, useRef } from "react";
import { Box, IconButton } from "@material-ui/core";
import useStyles from "../partners/components/3/styles";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Typography  from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import FlightIcon from "@material-ui/icons/Flight";
const Carousel = ({
  items = [],
  getTestimonialItem,
  itemsPerCarousel = 7,
  shiftBy = 2,
  center = false,
  toorThemeStepper = false,
  interval = 6000,
  itemWidthPx = 165,
  text = "",
  title,
  envytheme = false,
  styleObj={},
  buttonStyleObject={}
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);
const isBelow800 = useMediaQuery(theme.breakpoints.down(800));
  const handleNext = () => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    const shiftDistance = shiftBy * itemWidthPx;

    container.style.transition = "transform 0.8s ease-in-out";
    container.style.transform = `translateX(-${shiftDistance}px)`;

    setTimeout(() => {
      setActiveIndex((prev) => (prev + shiftBy) % items.length);

      container.style.transition = "none";
      container.style.transform = "translateX(0)";
    }, 800);
  };

  const handlePrev = () => {
    if (!containerRef.current) return;
    const container = containerRef.current;
    const shiftDistance = shiftBy * itemWidthPx;
    setActiveIndex((prev) => {
      const newIndex = prev - shiftBy;
      return newIndex < 0 ? items.length + newIndex : newIndex;
    });

    container.style.transition = "none";
    container.style.transform = `translateX(-${shiftDistance}px)`;
    void container.offsetHeight;

    container.style.transition = "transform 0.8s ease-in-out";
    container.style.transform = `translateX(0)`;
  };

  useEffect(() => {
    if (!toorThemeStepper) return;
    const timer = setInterval(handleNext, interval);
    return () => clearInterval(timer);
  }, [activeIndex, toorThemeStepper]);

  const getVisibleItems = () => {
    const visibleItems = [];
    for (let i = 0; i < itemsPerCarousel; i++) {
      const index = (activeIndex + i) % items.length;
      visibleItems.push(
        <Box
          key={index}
          className={classes.carouselItemContainer}
          style={{
            justifyContent: center ? "center" : "flex-start",
            width: `${itemWidthPx}px`,
          }}
        >
          {getTestimonialItem(items[index])}
        </Box>
      );
    }
    return visibleItems;
  };

  return (
    <Box>
      {toorThemeStepper && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={`${
            itemsPerCarousel * itemWidthPx + (itemsPerCarousel - 1) * 10
          }px`}
          margin="0 auto 2rem"
        >
          {title && (
            <Box width="100%">
              <Typography
                variant="h4"
                style={{
                  fontSize: styleObj?.fontSize || "28px",
                  fontWeight: styleObj?.fontWeight || 600,
                  color: theme.agentTheme.background.primary_text,
                  lineHeight: 1.2,
                  textAlign:styleObj?.textAlign || 'left'
                }}
              >
                {title}
              </Typography>
              {!envytheme && (
                <Box mt={1} display="flex" alignItems="center">
                  <FlightIcon
                    style={{
                      color: theme?.agentTheme?.primary?.main,
                      fontSize: 22,
                      transform: "rotate(90deg)",
                    }}
                  />
                  <Box
                    style={{
                      height: "1px",
                      width: "80px",
                      backgroundColor: theme?.agentTheme?.primary?.main,
                      margin: "-5px",
                    }}
                  />
                </Box>
              )}
            </Box>
          )}

          {/* Text + Navigation */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            marginTop="16px"
            flexDirection={envytheme && isBelow800 ? "column" : "row"}
          >
            <Typography
              variant="body1"
              style={{
                width: styleObj?.widthOfDes || "70%",
                display: "-webkit-box",
                WebkitLineClamp: styleObj?.linebreak || 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: theme?.agentTheme?.text?.body_text_color,
              }}
            >
              {text}
            </Typography>
            {!envytheme ? (
              <Box alignItems="center" gap="25px" mr={4} style={{display:buttonStyleObject?.display || 'flex'}}>
                <IconButton
                  size="small"
                  className={classes?.iconStyle}
                  onClick={handlePrev}
                >
                  <KeyboardBackspaceIcon
                    style={{ fontSize: 30, color: "inherit" }}
                  />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={handleNext}
                  className={classes?.iconStyle}
                >
                  <KeyboardBackspaceIcon
                    style={{
                      fontSize: 30,
                      transform: "rotate(180deg)",
                      color: "inherit",
                    }}
                  />
                </IconButton>
              </Box>
            ) : (
              <Box display="flex" alignItems="center" mr={4} style={{gap:"1rem"}} >
                <IconButton onClick={handlePrev} className={classes.navButton}>
                  <KeyboardBackspaceIcon />
                </IconButton>

                <IconButton onClick={handleNext} className={classes.navButton}>
                  <KeyboardBackspaceIcon
                    style={{ transform: "rotate(180deg)" }}
                  />
                </IconButton>
              </Box>
            )}
          </Box>
        </Box>
      )}

      <Box
        className={classes.carouselWrapper}
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
      >
        <Box display="flex" gap="10px" ref={containerRef}>
          {getVisibleItems()}
        </Box>
      </Box>
    </Box>
  );
};

export default Carousel;
